function onLoadImg () {
  let imgs = document.querySelectorAll('img')
  for (let i = 0; i < imgs.length; i++) {
    if (imgs[i].getBoundingClientRect().top < window.innerHeight) {
      if (imgs[i].dataset.src) {
        console.log(imgs[i].dataset.src)
        imgs[i].src = imgs[i].dataset.src
      }
    }
  }
}

function onLoadImgInWhere (where, scrollTop) {
  setTimeout(function () {
    let imgs = document.querySelectorAll(where + ' img')
    for (let i = 0; i < imgs.length; i++) {
      let imgTop = imgs[i].getBoundingClientRect().top
      // console.log('imgTop    ===>' + imgTop)
      // console.log('scrollTop ===>' + scrollTop)
      if (imgTop - 900 < scrollTop) {
        if (imgs[i].dataset.src) {
          //console.log(imgs[i].dataset.src)
          imgs[i].src = imgs[i].dataset.src
        }
      }
    }
  }, 500)

}

function onScrollImg (fn) {
  let timer = null
  let context = this
  let args = arguments //防抖
  return function () {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, 5000)
  }
}

export { onLoadImg, onLoadImgInWhere, onScrollImg }
